import store from '@/modules/store';

export default {
  // Requires the user to have access to manage settings
  canManageBilling() {
    return (to, from, next) => {
      if (store.state.user && store.state.user.canManageBilling) {
        return next();
      }

      next('/');
    };
  },

  // Requires the user to have access to manage settings
  canManageSettings() {
    return (to, from, next) => {
      if (store.state.user && store.state.user.canManageSettings) {
        return next();
      }

      next('/');
    };
  },

  // Requires the user to have access to manage sites
  canManageSites() {
    return (to, from, next) => {
      if (store.state.user && store.state.user.canManageSites) {
        return next();
      }

      next('/');
    };
  },

  // Requires the user to have access to manage users
  canManageUsers() {
    return (to, from, next) => {
      if (store.state.user && store.state.user.canManageUsers) {
        return next();
      }

      next('/');
    };
  },

  // Requires the user to be authenticated
  mustBeAuthenticated(options) {
    options = Object.assign(
      {
        bypassTfa: false
      },
      options
    );

    return (to, from, next) => {
      // User is logged in
      if (store.state.user) {
        // User requires TFA but has not been TFA authenticated
        if (store.state.user.requiresTfa && store.state.tfa && !store.state.tfa.isVerified && !options.bypassTfa) {
          return next('/login/tfa');
        }

        // Account requires TFA but user has not enabled it
        if (store.state.user.account.requiresTfa && !store.state.user.requiresTfa && !options.bypassTfa) {
          return next('/tfa');
        }

        return next();
      }

      // User is not logged in
      if (to.fullPath === '/') {
        next('/login');
      } else {
        next(`/login?to=${encodeURIComponent(to.fullPath)}`);
      }
    };
  },

  // Requires the user to be an admin
  mustBeAdmin() {
    return (to, from, next) => {
      if (store.state.user && store.state.user.isAdmin) {
        return next();
      }

      next('/');
    };
  },

  // Requires the user to be a superuser
  mustBeSuperuser() {
    return (to, from, next) => {
      if (store.state.user && store.state.user.isSuperuser) {
        return next();
      }

      next('/');
    };
  },

  // Requires the user to have a business or agency plan
  mustBeBusiness() {
    return (to, from, next) => {
      if (store.state.user && ['business', 'agency'].includes(store.state.user.account.plan)) {
        return next();
      }

      next('/');
    };
  },

  // Requires the user to have a business or better plan
  mustBeAgency() {
    return (to, from, next) => {
      if (store.state.user && store.state.user.account.plan === 'agency') {
        return next();
      }

      next('/');
    };
  },

  // Logs the user out before serving the router
  mustNotBeAuthenticated() {
    return (to, from, next) => {
      if (store.state.user && store.state.user.isAuthenticated) {
        return next('/');
      }

      next();
    };
  },

  mustNotHaveTfaEnabled() {
    return (to, from, next) => {
      if (store.state.user && store.state.user.requiresTfa) {
        return next('/');
      }

      next();
    };
  }
};
